import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabTasksComponent = /** @class */ (function () {
    function TabTasksComponent(data, fuseTranslationLoaderService) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.tasks = data.maintenance.tasks;
    }
    return TabTasksComponent;
}());
export { TabTasksComponent };
